<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <input type="month" v-model="fechaSaldos" class="form-control">
                    <b-button
                        class="consult-btn mx-3"
                        :disabled="!fechaSaldos"
                        @click="generaSaldos()"
                    >
                        {{ labels.procesar }}
                    </b-button>
                </div>
            </div>
        </div>

        <!-- <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaSaldos }}</h4> 
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="chkCierre == 1">
                <input type="month" :items="fechaSaldos" class="form-control" readonly>
            </div>
            <div v-else>
                <input type="month" :items="fechaSaldos" class="form-control">
            </div>
        </div>
        <b-row class="mt-4">
            <b-col class="d-flex justify-content-center">
                <b-button @click="generaSaldos" id="create-btn">{{ labels.procesar }}</b-button> 
            </b-col>
        </b-row> -->

        <!-- Spinner de carga -->
        <div v-if="loading" class="text-center py-5">
            <b-spinner></b-spinner>
            <p class="mt-2">{{ labels.loading }}</p>
        </div>
    </div>
</template>

<script>
import ContratoSaldos from '../../services/ContratoSaldos'; 
import FechaRegistro from '../../services/FechaRegistro'; 

export default {
    name : 'SaldosContables',
    data : () => ({
        fechaSaldos : '',
        chkCierre : 0,
        loading: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Saldos contables',
                    fechaSaldos : 'Fecha saldos:',
                    procesar : 'Procesar',
                    noRow : 'No hay registros',
                    loading : 'Cargando...',
                }
            }else{
                return {
                    title : 'Accounting balances',
                    fechaSaldos : 'Balance date:',
                    procesar : 'Process',
                    noRow : 'There are no records',
                    loading : 'Loading...',
                }
            }
        }
    },
    methods:{
        goBack(){
            this.$router.back()
        },
        generaSaldos(){
            // console.log('generaSaldos'); 
            if (this.fechaSaldos == '') { 
                this.$toast.error('Diligenciar la fecha.'); 
                return;
            }

            this.loading = true

            const datos = {
                fechaSaldos: this.fechaSaldos, 
                idUser: this.$store.state.userId 
            };
            // console.log(datos); 

            ContratoSaldos.generaSaldosContables(datos) 
            .then((res) => { 
                // console.log(res.data); 
                this.$toast.success(res.data.message) 
            }).catch((err) => { 
                console.log(err); 
            })
            .finally(() => { 
                this.loading = false 
            });
        }
    },
    mounted(){

        FechaRegistro.getAllFechaRegistro() 
        .then((res) => { 
            // console.log(res.data); 
            this.fechaSaldos = res.data.periodo_cierre 
            this.chkCierre = res.data.flag_cierre 
        })
        .catch((err) => { 
            console.log(err); 
            if(err.response.status == 500){ 
                this.$toast.error(err.response.data.msg) 
            }else{
                this.$toast.error("Algo pasó, intentalo de nuevo") 
            }
        })
    }
}
</script>

<style>

</style>
